import gql from 'graphql-tag';

const SAVE_TICKET_CONVERSATION = gql`
  mutation(
    $ticketId: ID!
    $content: String
    $fromMailbox: MailboxIdentifierInput
    $toUsers: [UserInput]
    $ccUsers: [UserInput]
    $bccUsers: [UserInput]
    $enableSurvey: Boolean
    $createTicketFlow: Boolean
    $attachments: [AttachmentInput]
    $inlineImages: [String]
    $ticketInput: TicketInput
    $hasAdditionalRecipients: Boolean
  ) {
    saveTicketConversation(
      ticketId: $ticketId
      input: {
        content: $content
        toUsers: $toUsers
        ccUsers: $ccUsers
        bccUsers: $bccUsers
        enableSurvey: $enableSurvey
        createTicketFlow: $createTicketFlow
        attachments: $attachments
        inlineImages: $inlineImages
        fromMailbox: $fromMailbox
        hasAdditionalRecipients: $hasAdditionalRecipients
      }
      ticketInput: $ticketInput
    ) {
      content
      time
      user {
        userId
        firstName
        lastName
        email
        name
      }
      outgoingMailStatus
      outgoingMailFailureReason
      attachments {
        fileName
        originalFileName
        fileSize
      }
      type
      conversationId
      toUsers {
        user {
          userId
          firstName
          lastName
          name
          email
        }
        mailDeliveryStatus
        mailFailureReason
      }
      ccUsers {
        user {
          userId
          firstName
          lastName
          name
          email
        }
        mailDeliveryStatus
        mailFailureReason
      }
      bccUsers {
        user {
          userId
          firstName
          lastName
          name
          email
        }
        mailDeliveryStatus
        mailFailureReason
      }
    }
  }
`;

const SAVE_TICKET_INTEGRATION_CONVERSATION = gql`
  mutation(
    $ticketId: ID!
    $content: String
    $attachments: [AttachmentInput]
    $sendMail: Boolean
    $conversationScope: ConversationScope
    $recipientDetails: [ConversationThreadRecipientInput]
    $ticketInput: TicketInput
  ) {
    saveTicketConversation(
      ticketId: $ticketId
      input: {
        content: $content
        attachments: $attachments
        sendMail: $sendMail
        conversationScope: $conversationScope
        recipientDetails: $recipientDetails
      }
      ticketInput: $ticketInput
    ) {
      content
      time
      attachments {
        fileName
        originalFileName
        fileSize
      }
      type
      conversationId
      conversationStatus
      failureReason
      recipientDetails {
        user {
          userId
          name
          email
        }
        label
        conversationRecipientType
      }
      conversationScope
    }
  }
`;
export { SAVE_TICKET_CONVERSATION, SAVE_TICKET_INTEGRATION_CONVERSATION };
